import React from 'react';

type Props = {
  size: number;
};
export const ListIcon = ({ size = 32 }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M27 23v4H11v-4h16zM9 23v4H5v-4h4zm18-6v4H11v-4h16zM9 17v4H5v-4h4zm18-6v4H11v-4h16zM9 11v4H5v-4h4zm0-6v4H5V5h4zm18 0v4H11V5h16z"
      />
    </g>
  </svg>
);
